export const recaptchaKey = "6LfQiu4gAAAAABq0hrho2HzgzQCSjd-0z1dPqgYe";
